<div class="cashback-main-container text">
  <div class="cashback-header">{{ 'Cashback_Your_Cashback_Status' | t }}</div>
  <div class="cashback-item">
    <div class="cashback-left-row">{{ 'Cashback_Your_Promotion_period' | t }}</div>
    <div class="cashback-right-row">{{ date }}</div>
  </div>
  <div class="cashback-item">
    <div class="cashback-left-row">{{ 'Cashback_Your_Text_1' | t }}</div>
    <div class="cashback-right-row value" *ngIf="cashbackBalance != null">{{ cashbackBalance | number : '1.2-2' }} {{ this._UserHelper.customerUser?.Symbol }}</div>
  </div>
  <div class="cashback-item-alert" *ngIf="cashbackBalance == 0 || cashbackBalance == null">
    {{ 'b3000_cashback_text_1' | t }}
  </div>
  <ng-container [ngSwitch]="['wettarena'] | getProductName">
    <ng-container *ngSwitchCase="'wettarena'">
      <div class="btn colored blue btn-credit" *ngIf="!hasNoCashback" (click)="joinCashback()">
        <div class="login-button-text">
          {{ 'CASHBACK' | t }}
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
